import { render, staticRenderFns } from "./verificationCode-list.vue?vue&type=template&id=4c94b20b&scoped=true&"
import script from "./verificationCode-list.vue?vue&type=script&lang=js&"
export * from "./verificationCode-list.vue?vue&type=script&lang=js&"
import style0 from "./verificationCode-list.vue?vue&type=style&index=0&id=4c94b20b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c94b20b",
  null
  
)

export default component.exports